import { toast } from 'sonner';

/**
 * Copy ``text``, falling back to a hidden textarea when the Clipboard API is
 * refused (an unfocused document, a permissions policy, an older browser).
 * True when either path copied.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    try {
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      area.remove();
    }
  }
}

/**
 * A table cell's click-to-copy: the cell has no icon to flip to a check, so
 * a short toast says it worked. Replay 2026-10-23 showed users clicking
 * cells again and again with no sign anything happened.
 */
export async function copyCellValue(text: string): Promise<void> {
  if (await copyText(text)) {
    toast.success('Copied', { duration: 1500 });
  } else {
    toast.error("Couldn't copy. Select the text and copy it instead.");
  }
}
